import service from '@/services'

function extractList(payload) {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []
  if (Array.isArray(payload.data)) return payload.data
  if (payload.data && Array.isArray(payload.data.data)) return payload.data.data
  if (Array.isArray(payload.record)) return payload.record
  if (Array.isArray(payload.records)) return payload.records
  return []
}

// Module Vuex gudang
export default {
  namespaced: true,
  state: {
    datas: [],
    stokMobil: [],
    vehicles: [],
    activeKendaraan: null,
    my_sales_rutes: [],
  },
  getters: {
    findVehicle: state => id => state.vehicles.find(v => v.id == id),
  },
  mutations: {
    SET_SALES_RUTES(state, datas) {
      state.my_sales_rutes = datas
    },
    SET_GUDANG_MOBIL(state, data) {
      state.vehicles = data
    },
    SET_DATA(state, data) {
      state.datas = data
    },
    SET_STOK_MOBIL(state, data) {
      state.stokMobil = data
    },
    SET_ACTIVE_KENDARAAN(state, data) {
      state.activeKendaraan = data
    },
  },
  actions: {
    async getMySalesRute({ commit }, params) {
      try {
        const config = {
          url: '/gudang-sales-rute',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = extractList(response.data)
        commit('SET_SALES_RUTES', result)

        return Promise.resolve(result)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getData({ commit }, params = {}) {
      try {
        const config = {
          url: '/gudang',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = extractList(response.data)
        const total = response.data && typeof response.data.total !== 'undefined'
          ? response.data.total
          : result.length
        commit('SET_DATA', result)

        // Keep array return for existing callers; attach total for server-side pages
        return Promise.resolve(Object.assign(result, { total }))
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDataById({}, id) {
      try {
        const config = {
          url: `/gudang/${id}`,
          method: 'get',
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async save({}, payload = {}) {
      try {
        const config = {
          url: '/input/gudang',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDataStokMobil({ commit }, params = {}) {
      try {
        const config = {
          url: '/stok-mobil',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        // State terpisah agar tidak tertimpa getData('/gudang') dari modal/list
        const result = extractList(response.data)
        commit('SET_STOK_MOBIL', result)

        return Promise.resolve(result)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
